import React, { useState } from "react";
import { DelayInput } from "react-delay-input/lib/Component";
import DefaultButton from "../../../../styles/materialButtonStyle";
import DatePicker from "../../../../elements/datePicker/DatePicker";
import { DateToTimestamp, TimestampToDate } from "../../../../../utils/timestampToDate";
import Dropdown from "rc-dropdown";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

import { StyledDatepicker } from "../../../../styles/styledDatepicker";
import {
  StyledFilterBlock,
  StyledFilterBlockTitle,
  StyledFilterCloseBtn,
  StyledFilterDropdownWrapper,
  StyledFilterGroup,
  StyledFilterWrapper,
  StyledSelectGroup,
  StyledShowFilterBtn
} from "../../../../elements/filter/styledFiter";
import ServicesSelect from "./ServicesSelect";

const ProjectConnectionsFilter = ({ t, filterData, setFilterData }) => {

  const DEFAULT_FILTER_DATA = {
    "page": 1,
    "currentTab": filterData["currentTab"],
    "itemsPerPage": filterData["itemsPerPage"] ?? null,
    "service.name": null,
    "id": "",
    "enablePayment": null,
    "enablePayout": null,
    "createDate[gte]": null,
    "createDate[lte]": null
  };

  const [visible, setVisible] = useState(false);

  const onVisibleChange = (visible) => {
    setVisible(visible);
  };

  const handleClearFilter = () => {
    setFilterData(DEFAULT_FILTER_DATA);
  };

  const FilterList = () => {
    return (
      <>
        {visible &&
        <StyledFilterDropdownWrapper>
          <StyledFilterBlock actions>
            <StyledFilterGroup className="clear-btn">
              <DefaultButton
                color="transparent"
                onClick={handleClearFilter}
              >
                {t("details.connections.filter.clearBtn")}
              </DefaultButton>
            </StyledFilterGroup>
            <StyledFilterGroup className="close-btn">
              <StyledFilterCloseBtn onClick={() => setVisible(false)} />
            </StyledFilterGroup>
          </StyledFilterBlock>
          <StyledFilterBlockTitle>
            {t("details.connections.filter.filterBy")}:
          </StyledFilterBlockTitle>
          <StyledFilterBlock col="2">
            <StyledSelectGroup>
              <ServicesSelect
                checkedService={filterData["service.name"]}
                setCheckedService={(data) => setFilterData({ ...filterData, "service.name": data, page: 1 })}
                isObject={false}
                defaultOption={true}
              />
            </StyledSelectGroup>
            <StyledFilterGroup>
              <label htmlFor="name">UUID</label>
              <DelayInput
                id="id"
                delayTimeout={2000}
                onChange={event => setFilterData({ ...filterData, "id": event.target.value, page: 1 })}
                name="id"
                value={filterData["id"]}
                type="text"
                placeholder={t("details.connections.filter.example", { value: "0123A3a1-0123-4321-0dd3-ab0d456789kl" })}
              />
            </StyledFilterGroup>
            <StyledFilterGroup>
              <InputLabel id="status-simple-select-label-enable-payment">
                {t("details.connections.filter.payment")}
              </InputLabel>
              {/* No need to change on Autocomplete component (few options) */}
              <Select
                labelId="status-simple-select-label-enable-payment"
                id="status-simple-select-enable-payment"
                value={filterData["enablePayment"]}
                onChange={event => setFilterData({ ...filterData, "enablePayment": event.target.value, page: 1 })}
              >
                <MenuItem value={null}>{t("details.connections.filter.all")}</MenuItem>
                <MenuItem value={true}>{t("details.connections.filter.active")}</MenuItem>
                <MenuItem value={false}>{t("details.connections.filter.inActive")}</MenuItem>
              </Select>
            </StyledFilterGroup>
            <StyledFilterGroup>
              <InputLabel id="status-simple-select-label-enable-payout">
                {t("details.connections.filter.payout")}
              </InputLabel>
              {/* No need to change on Autocomplete component (few options) */}
              <Select
                labelId="status-simple-select-label-enable-payout"
                id="status-simple-select-enable-payout"
                value={filterData["enablePayout"]}
                onChange={event => setFilterData({ ...filterData, "enablePayout": event.target.value, page: 1 })}
              >
                <MenuItem value={null}>{t("details.connections.filter.all")}</MenuItem>
                <MenuItem value={true}>{t("details.connections.filter.active")}</MenuItem>
                <MenuItem value={false}>{t("details.connections.filter.inActive")}</MenuItem>
              </Select>
            </StyledFilterGroup>
          </StyledFilterBlock>
          <StyledFilterBlockTitle>
            {t("details.connections.filter.date")}:
          </StyledFilterBlockTitle>
          <StyledFilterBlock col="2">
            <StyledDatepicker>
              <label htmlFor="dateFrom">
                {t("details.connections.filter.dateFrom")}
              </label>
              <DatePicker
                format="dd-MM-y"
                id="dateFrom"
                name="dateFrom"
                className="date-input"
                onChange={dateFrom => setFilterData({
                  ...filterData,
                  "createDate[gte]": DateToTimestamp(dateFrom),
                  page: 1
                })}
                value={TimestampToDate(filterData["createDate[gte]"])}
              />
            </StyledDatepicker>
            <StyledDatepicker>
              <label htmlFor="dateTo">
                {t("details.connections.filter.dateTo")}
              </label>
              <DatePicker
                format="dd-MM-y"
                id="dateTo"
                name="dateTo"
                className="date-input"
                onChange={dateTo => setFilterData({
                  ...filterData,
                  "createDate[lte]": DateToTimestamp(dateTo),
                  page: 1
                })}
                value={TimestampToDate(filterData["createDate[lte]"])}
              />
            </StyledDatepicker>
          </StyledFilterBlock>
        </StyledFilterDropdownWrapper>}
      </>
    );
  };

  return (
    <StyledFilterWrapper id="filter">
      <Dropdown
        getPopupContainer={() => document.getElementById("filter")}
        overlay={FilterList}
        trigger={["click"]}
        placement="bottomLeft"
        onVisibleChange={onVisibleChange}
        visible={visible}
        closeOnSelect={false}
      >
        <StyledShowFilterBtn>
          <DefaultButton
            color="success"
          >
            {t("details.connections.filter.filterBtn")}
          </DefaultButton>
        </StyledShowFilterBtn>
      </Dropdown>
    </StyledFilterWrapper>
  );
};

export default ProjectConnectionsFilter;